import StyledTypo from '@tmh-website/styles/typo';
import { formElementThemes } from '@tmh-website/ui/FormElements';
import styled from 'styled-components';
import { CalendarThemeColor, calendarThemes } from './Calendar.theme';

export const CalendarContainer = styled.div<{ $themeColor: CalendarThemeColor }>`
  display: flex;
  justify-content: center;
  padding: 20px 12px 12px;
  @media (${props => props.theme.breakpoint.sm.up}) {
    padding: 12px;
  }

  .rdp {
    background: ${props => props.theme.color[calendarThemes[props.$themeColor].background]};
  }

  .day-picker-table {
    width: 100%;
    max-width: 380px;
    margin: 0 auto;
    border-spacing: 0;
    border-collapse: separate;
    box-shadow: none;
    @media (${props => props.theme.breakpoint.sm.up}) {
      width: auto;
      margin: 0;
      border-spacing: 6px;
    }
  }

  .day-picker-table,
  .day-picker-cell {
    background: none;
    border: none;
  }
`;

export const Row = styled.tr<{ $opacity?: number }>`
  background: none;
  ${props => props.$opacity !== undefined && `opacity: ${props.$opacity};`}
`;

export const Cell = styled.td<{ $themeColor: CalendarThemeColor }>`
  width: 44px;
  height: 44px;
  aspect-ratio: 1;
  padding: 0;
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].text]};
  text-align: center;
  background: none;
  border: none;
  @media (${props => props.theme.breakpoint.sm.up}) {
    width: 34px;
    height: 34px;
  }
`;

export const Weekday = styled(Cell)`
  ${StyledTypo.uiTextCss};
`;

export const Caption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  margin-bottom: 4px;
`;
